var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-share-list-container"},[_c('ul',{staticClass:"image-share-list"},[_c('li',{staticClass:"image-share-item"},[_c('a',{staticClass:"image-share-link",attrs:{"href":"#"},on:{"click":_vm.handleDownload}},[_c('span',{staticClass:"iconfont"},[_vm._v(" 点击下载【"+_vm._s(_vm.btnTitle)+"】到本地 ")])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }